import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "flex q-ma-lg justify-center" }
const _hoisted_2 = { class: "text-italic" }


// eslint-disable-next-line import/no-cycle
import router from '@/router';
import { ref } from 'vue';

const __default__ = { name: 'DashboardView' };

export default /*@__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {


const greet = ref('Бобро пожаловац');

const goToScaner = () => {
  router.push({ name: 'DocumentScanner' });
};

return (_ctx: any,_cache: any) => {
  const _component_q_btn = _resolveComponent("q-btn")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("p", _hoisted_2, _toDisplayString(greet.value), 1),
    _createVNode(_component_q_btn, {
      label: "сканер",
      onClick: goToScaner
    })
  ]))
}
}

})